import React from 'react'
import css from './button.module.scss'

interface IProps extends React.AllHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void
  text: string
  type?: 'button' | 'submit' | 'reset'
}

export default function LinkButton({ onClick, text, type, ...props }: IProps) {
  return (
    <button className={css.link_button} type={type} onClick={onClick} {...props}>
      {text}
    </button>
  )
}
